// based on https://gist.github.com/Tombarr/1005b5ac623e7f9ea9562ff2a0f17061

const NOPE = () => {
  throw new Error("Can't modify read-only view");
}

const handler = {
  // recursively wrap returned objects in readonly
  get: (obj:any, prop:string):any => {
    if (prop === 'toJSON') {
      return JSON.stringify(obj);
    }
    if (prop in obj) {
      const value = obj[prop];
      return (value !== null && (typeof value === 'object')) ? readonly(value) : value;
    }
  },
  set: NOPE,
  defineProperty: NOPE,
  deleteProperty: NOPE,
  preventExtensions: NOPE,
  setPrototypeOf: NOPE
}

export const readonly = <T> (target:T):Readonly<T> => new Proxy(target, handler);